import React from "react";
//outsource
import { DatePicker, message } from "antd";
import moment from "moment";

//components

const DialogWeekTo = ({ from, to, setTo, onChange, disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (time) => {
    console.log(time);
    if (from  && to && from > time) {
      message.warning(
        "The end time of work is earlier than the start time of work."
      );
    } else {
      setTo(time);
      onChange("endAt", time);
    }
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      placeholder="To Time"
      value={to}
      picker="time"
      onChange={handleChange}
      allowClear={false}
      format="hh:mm A"
      disabled={disabled}
      getPopupContainer={(trigger) => trigger.parentElement}
      dropdownClassName="time-picker"
      onSelect={handleChange}
    />
  );
};

export default DialogWeekTo;
